import getDefaultDomain from '../helpers/getDefaultDomain';
import { getDatasetUid, getDomain, getParameterOverrides, getReadFromNbe } from '../helpers/VifSelectors';
import { Vif } from '../vif';
import { MetadataProviderConfig, SoqlDataProviderConfig } from './types';

export const getMetaDataProviderConfigFromVif = (vif: Vif): MetadataProviderConfig => {
  return {
    datasetUid: getDatasetUid(vif),
    domain: getDomain(vif) || getDefaultDomain(),
    readFromNbe: getReadFromNbe(vif),
  };
};

export const getSoqlDataProviderConfigFromVif = (vif: Vif): SoqlDataProviderConfig => {
  const datasetProviderConfig = getMetaDataProviderConfigFromVif(vif);
  return {
    ...datasetProviderConfig,
    clientContextVariables: getParameterOverrides(vif),
  };
};
